import * as React from 'react';
import { History } from 'lucide-react';

import { Botao } from '@/components/ui/button';
import {
  Dialogo,
  DialogoCabecalho,
  DialogoConteudo,
  DialogoCorpo,
  DialogoDescricao,
  DialogoTitulo,
} from '@/components/ui/dialog';
import { HistoricoPaciente } from './historico-paciente';

/**
 * Botão "Hist. Paciente" da tela da solicitação.
 *
 * Só consulta ao abrir o modal — montar a tela do pedido não deve disparar
 * duas chamadas externas auditadas que ninguém pediu. O paciente é resolvido
 * no backend a partir da solicitação.
 */
export function BotaoHistoricoPaciente({ solicitacaoId }: { solicitacaoId: string }) {
  const [aberto, setAberto] = React.useState(false);

  return (
    <>
      <Botao variante="contorno" tamanho="sm" onClick={() => setAberto(true)}>
        <History aria-hidden="true" />
        Hist. Paciente
      </Botao>

      <Dialogo open={aberto} onOpenChange={setAberto}>
        <DialogoConteudo className="max-w-5xl">
          <DialogoCabecalho>
            <DialogoTitulo>Histórico do paciente</DialogoTitulo>
            <DialogoDescricao>
              Registros no eSUS Regulação e no SISREG 3. A consulta fica registrada na auditoria.
            </DialogoDescricao>
          </DialogoCabecalho>
          <DialogoCorpo>
            <HistoricoPaciente chave={{ solicitacaoId }} />
          </DialogoCorpo>
        </DialogoConteudo>
      </Dialogo>
    </>
  );
}
